<div class="summary-trial-bal-wf-container">
  <div class="modal-body">
    <h4 class="text-center"><b>Summary Trail Balance</b></h4>
    <div>
      <table class="table table-bordered text custom-table">
        <thead style="text-align: center">
          <tr>
            <th>Summary TB Description</th>
            <th>Trail Balance Amount</th>
            <th>Submitter Reclass Adjustment</th>
            <th>11/30 Prior Year December</th>
            <th>11/30 Current Year December</th>
            <th>Reviewer Reclass Adjustments</th>
            <th>Current Year Amount</th>
            <th>Prior Year Amount</th>
            <th>Varinace Amount</th>
            <th>Variance</th>
          </tr>
          <tr>
            <th></th>
            <th align="center">(a)</th>
            <th align="center">(b)</th>
            <th align="center">(c)</th>
            <th align="center">(d)</th>
            <th align="center">(e)</th>
            <th align="center">(f=a+b+c+d+e)</th>
            <th align="center">(g)</th>
            <th align="center">(h=f-g)</th>
            <th align="center">(h/g)*100</th>
          </tr>
        </thead>
        <tbody>
          @for (item of trailBal; track $index) {
<tr>
            <td>{{ item.assets }}</td>
            <td class="text-right">{{ item.tria_bal_amnt }}</td>
            <td align="right">{{ item.subreclass_adj }}</td>
            <td align="right">{{ item.prior_11_30 }}</td>
            <td align="right">{{ item.curr_11_30 }}</td>
            <td align="right">{{ item.review_relcass }}</td>
            <td align="right">{{ item.currnt_year_amt }}</td>
            <td align="right">{{ item.prior_year }}</td>
            <td align="right">{{ item.varia_amnt }}</td>
            <td align="right">{{ item.variance }}</td>
          </tr>
}
        </tbody>
      </table>
    </div>
  </div>
</div>
